import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { images as imageApi } from '../../utils/api';

const TimelineItem = memo(({
  coin,
  index,
  isShared,
  onCoinClick,
  formatDate
}) => {
  const imagePath = coin.images?.[0] 
    ? imageApi.getImage(coin.images[0].file_path, coin.images[0].source) 
    : '/images/placeholder.svg';

  return (
    <motion.div
      className={`flex items-center ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}
      initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: Math.min(index * 0.1, 2) }}
    >
      <div className="w-[calc(50%-1rem)] sm:w-1/2">
        <div className="flex justify-center">
          <div 
            className={`bg-white p-3 sm:p-4 lg:p-6 rounded-lg shadow-lg w-[280px] sm:w-[360px] lg:w-[440px] ${
              index % 2 === 0 
                ? 'mr-4 sm:mr-8 lg:mr-12' 
                : 'ml-4 sm:ml-8 lg:ml-12'
            }`}
          >
            <div 
              className="relative w-full aspect-square bg-gray-100 rounded-lg mb-3 sm:mb-4 lg:mb-6 overflow-hidden cursor-pointer"
              onClick={() => onCoinClick(coin)}
            >
              <img
                src={imagePath}
                alt={`${coin.year} ${coin.denomination}`}
                className="w-full h-full object-contain p-2 lg:p-4"
                loading="lazy"
              />
            </div>
            <h3 className="text-lg font-semibold text-center">{coin.year} {coin.denomination}</h3>
            <p className="text-sm text-gray-600 text-center">{coin.grade}</p>
            <p className="text-xs text-gray-500 text-center mt-1">
              {formatDate(coin.purchase_date || coin.created_at, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              })}
            </p>
          </div>
        </div>
        <div className="absolute left-1/2 transform -translate-x-1/2 w-3 h-3 sm:w-4 sm:h-4 bg-indigo-600 rounded-full" />
      </div>
    </motion.div>
  );
});

const TimelineView = memo(({ 
  coins, 
  isShared, 
  onCoinClick,
  formatDate 
}) => {
  if (!coins || coins.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-[400px] text-gray-600">
        No coins available in this set
      </div>
    );
  }
  
  return (
    <div className="relative p-3 sm:p-6">
      <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gray-200" />
      <div className="space-y-8 sm:space-y-12">
        {coins.map((coin, index) => (
          <TimelineItem
            key={coin.id}
            coin={coin}
            index={index}
            isShared={isShared}
            onCoinClick={onCoinClick}
            formatDate={formatDate}
          />
        ))}
      </div>
    </div>
  );
});

export default TimelineView;
